import service from '@/store/services/employers/workplaces-service';

const state = {
    list: {},
    workplace: {},
    meta: {},
    statistics: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, workplace) => {
        state.workplace = workplace;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_STATISTICS: (state, statistics) => {
        state.statistics = statistics;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(workplace => {
                commit('SET_RESOURCE', workplace);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(workplace => {
                commit('SET_RESOURCE', workplace);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((workplace) => {
                commit('SET_RESOURCE', workplace);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((workplace) => {
                commit('SET_RESOURCE', workplace);
            });
    },
    updateStatus ({ commit, dispatch }, params) {
        return service.updateStatus(params)
            .then((workplace) => {
                commit('SET_RESOURCE', workplace);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
    statusStatistics ({ commit, dispatch }, params) {
        return service.getStatusStatistics(params)
            .then((statistics) => {
                commit('SET_STATISTICS', statistics);
            });
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    workplace: state => state.workplace,
    statistics: state => state.statistics,
    dropdown: (state) => {
        return state.list.map(workplace => ({
            id: workplace.id,
            name: workplace.name,
            location: workplace.location
        }));
    }
};

const workplaces = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default workplaces;
